import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";

interface AnimeCardProps {
  anime: Anime;
  className?: string;
}

export default function AnimeCard({ anime, className = "" }: AnimeCardProps) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 ${className}`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={anime.title}
          title={`${anime.title} - 58动漫作品`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {typeof anime.rating === "number" && (
          <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-full border border-primary-200 bg-background-50/90 px-2 py-0.5 text-xs font-bold text-primary-600 backdrop-blur">
            <i className="ri-star-fill text-[11px]" />
            {anime.rating.toFixed(1)}
          </span>
        )}
        <span
          className={`absolute bottom-2 left-2 rounded-full px-2 py-0.5 text-[11px] font-medium ${
            anime.status === "连载中"
              ? "bg-accent-500 text-background-50"
              : "bg-secondary-200 text-secondary-900"
          }`}
        >
          {anime.status}
        </span>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {anime.title}
        </h3>
        <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[11px] text-foreground-500">
          <span>{anime.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{anime.region}</span>
          <span className="text-foreground-300">·</span>
          <span>共 {anime.episodes} 集</span>
        </div>
        <div className="flex flex-wrap gap-1">
          {anime.types.slice(0, 3).map((type) => (
            <span
              key={type}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {type}
            </span>
          ))}
        </div>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{anime.synopsis}</p>
      </div>
    </Link>
  );
}